import styled from 'styled-components';

export const ModuleContainer = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: row;
  box-sizing: border-box;
`;

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
`;
